import { ButtonBase, styled } from '@mui/material';

export const ButtonContainer = styled(ButtonBase)`
  justify-content: flex-start;
  gap: 4px;
`;
